module.exports = __webpack_public_path__ + "img/hy.96339e20.svg";